import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Tabs, Tab, Form } from "react-bootstrap";
import {
  getCarAllDetailsList,
  getCarModelByVin,
  getCarModelDetailsList,
  getCarTreeByCar,
  getPartByGroup,
  getPartByPrice,
  getSchemaByGroup,
  getVehicleProcessDetails,
} from "../../services/VehicleService";
import Utils from "../../utils";
import { toast } from "react-toastify";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import {
  createVehicleAddPartAssignCatalog,
  getVehicleAddPartAssignCatalog,
} from "../../services/PartsInventory";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";
import { getPartCatalogList } from "../../services/LerCatalogService";

const VehicleModelByVIN = ({
  setActiveTab,
  vehicleProcessList,
  activeTab,
  vehicleId,
  setVehicleProcessList,
}) => {
  let ownerId = localStorage.getItem("ownerList");

  const navigate = useNavigate();
  const { t } = useTranslation();
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const [key, setKey] = useState("carSelection");
  const [search, setSearch] = useState("");

  const [vehicleVinLiveList, setVehicleVinLiveList] = useState([]);
  const [vehicleVinLocalList, setVehicleVinLocalList] = useState([]);
  const [loadingVinType, setLoadingVinType] = useState(null);
  const [modalCarVin, setModalCarVin] = useState(null);
  const [showTab2, setShowTab2] = useState(false);
  const [showTab3, setShowTab3] = useState(false);
  const [showTabInteractive, setShowTabInteractive] = useState(false);

  const [modalInfo, setModalInfo] = useState(false);
  const [infoData, setInfoData] = useState("");
  const [partCatalogData, setPartCatalogData] = useState([]);
  const [partCatalogLiveData, setPartCatalogLiveData] = useState([]);
  const [loadingTreeCar, setLoadingTreeCar] = useState(false);
  const [showAllList, setShowAllList] = useState(
    Array(
      partCatalogLiveData?.length > 0
        ? partCatalogLiveData?.length
        : partCatalogData?.length
    ).fill(false)
  );
  const [mainCatalogData, setMainCatalogData] = useState("");
  const [schemaByGroupLiveData, setSchemaByGroupLiveData] = useState([]);
  const [schemaByGroupLocalData, setSchemaByGroupLocalData] = useState([]);
  const [showAlTypeList, setShowAllTypeList] = useState(
    Array(
      schemaByGroupLiveData?.length > 0
        ? schemaByGroupLiveData?.length
        : schemaByGroupLocalData?.length
    ).fill(false)
  );
  const [partByGroupLiveData, setPartByGroupLiveData] = useState("");

  const [mainPartData, setMainPartData] = useState("");
  const [codeData, setCodeData] = useState("");
  const [partPriceLiveData, setPartPriceLiveData] = useState([]);
  const [partPriceLocalData, setPartPriceLocalData] = useState([]);
  const [priceModal, setpriceModal] = useState(false);
  const [partModal, sePartModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [addedParts, setAddedParts] = useState([]);
  const [categoryPartList, setCategoryPartList] = useState([]);
  const [params, setParams] = useState({
    limit: 20,
    search: "",
    is_reload: false,
    company_id: companyId.company_id || 0,
    page: 1,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [partData, setPartData] = useState("");
  const [partAssignDetails, setPartAssignDetails] = useState("");
  const [selectedCarModelId, setSelectedCarModelId] = useState(null);
  const [vinLoading, setVinLoading] = useState(false);
  const [carAllDetails, setCarAllDetails] = useState("");
  const [itemCarType, setItemCarType] = useState("");
  const [localVinList, setLocalVinList] = useState([]);

  useEffect(() => {
    // When modal opens, copy the latest data
    if (modalCarVin) {
      setLocalVinList(vehicleVinLiveList);
    }
  }, [modalCarVin, vehicleVinLiveList]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };

    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
    } else if (type === "pagination") {
      paramsObj.page = e;
    }

    setParams(paramsObj);
  };

  const handleAddClick = (item) => {
    const catalogId = item.id || item.catalog_id;

    const exists = addedParts.some(
      (part) => Number(part.catalog_id) === Number(catalogId)
    );

    if (!exists) {
      const itemToAdd = {
        ...item,
        catalog_id: catalogId, // ensure consistent structure
      };
      setAddedParts((prev) => [...prev, itemToAdd]);
    }
  };

  const handleRemoveClick = (catalog_id) => {
    setAddedParts((prev) =>
      prev.filter((part) => part.catalog_id !== catalog_id)
    );
  };

  const filteredPartAssignList = categoryPartList.filter(
    (item) =>
      !addedParts.some(
        (added) =>
          Number(added.catalog_id) === Number(item.id || item.catalog_id)
      )
  );

  const toggleRowLive = (item) => {
    setCodeData(item);

    if (item) {
      const obj = {
        catalogId: mainCatalogData?.catalog_id,
        code: item,
        status: 1,
      };

      getPartByPrice(obj)
        .then((response) => {
          const dataWithStatus = response.data.data.map((item) => ({
            ...item,
            status: 1,
          }));
          setPartPriceLiveData(dataWithStatus);
          setpriceModal(true);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setLoadingTreeCar(false);
        });
    }
  };

  const toggleRowLocal = (item) => {
    setCodeData(item);

    if (item) {
      const obj = {
        catalogId: mainCatalogData?.catalog_id,
        code: item,
        status: 2,
      };

      getPartByPrice(obj)
        .then((response) => {
          const dataWithStatus = response.data.data.map((item) => ({
            ...item,
            status: 2,
          }));
          setPartPriceLocalData(dataWithStatus);
          setpriceModal(true);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setLoadingTreeCar(false);
        });
    }
  };

  const toggleShowAll = (index) => {
    const updated = [...showAllList];
    updated[index] = !updated[index];
    setShowAllList(updated);
  };

  const toggleShowTypeAll = (index) => {
    const updated = [...showAlTypeList];
    updated[index] = !updated[index];
    setShowAllTypeList(updated);
  };

  useEffect(() => {
    const storedItem = localStorage.getItem("selectedCatalogItem");
    if (storedItem) {
      setMainCatalogData(JSON.parse(storedItem));
    }
  }, []);

  useEffect(
    function () {
      let data = { ...params };
      getPartCatalogList(data)
        .then((response) => {
          setCategoryPartList(response.data.data);
          setTotalRecords(response.data.total);
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
    },
    [params]
  );

  useEffect(() => {
    if (vehicleProcessList?.vehicle_frame) {
      setSearch(vehicleProcessList?.vehicle_frame);
    }
  }, [vehicleProcessList]);

  useEffect(
    function () {
      if (partData) {
        let data = {
          car_model_id: partData?.id,
          vehicle_id: vehicleProcessList?.vehicle_id
            ? vehicleProcessList?.vehicle_id
            : vehicleId,
        };
        getVehicleAddPartAssignCatalog(data)
          .then((response) => {
            setPartAssignDetails(response.data.data);
          })
          .catch((err) => {
            toast.dismiss();
            toast.error(Utils.getErrorMessage(err));
          });
      }
    },
    [partData]
  );

  useEffect(
    function () {
      if (partAssignDetails) {
        setAddedParts(partAssignDetails);
      }
    },
    [partAssignDetails]
  );
  const handleCarVinModalClose = () => {
    let data = {
      vehicle_id: vehicleId ? vehicleId : "",
      data_type: activeTab,
      owner_id: ownerId,
    };

    getVehicleProcessDetails(data)
      .then((response) => {
        setVehicleProcessList(response.data.data);
      })
      .catch((err) => {});
    if (vehicleProcessList?.car_model_id) {
      const obj = {
        carId: vehicleProcessList.car_model_id,
      };
      getCarModelDetailsList(obj)
        .then((response) => {
          setModalCarVin(false);
          setCarAllDetails(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setVinLoading(false);
        });
    }
    setModalCarVin(false);
    setShowTabInteractive(false);
    setShowTab2(false);
    setShowTab3(false);
  };
  const handleInfoModalClose = () => {
    setModalInfo(false);
  };

  const handlePriceClose = () => {
    setpriceModal(false);
  };

  const handlePartClose = () => {
    sePartModal(false);
  };

  useEffect(() => {
    if (vehicleProcessList?.car_model_id) {
      const obj = {
        carId: vehicleProcessList.car_model_id,
      };
      getCarModelDetailsList(obj)
        .then((response) => {
          setModalCarVin(false);
          setCarAllDetails(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setVinLoading(false);
        });
    }
  }, [vehicleProcessList]);

  const handleSaveVin = (e) => {
    e.preventDefault();

    const obj = {
      vin: search,
      lang: "pt",
      catalogId: selectedCarModelId?.infoData?.catalog_id,
      carId: selectedCarModelId?.infoData?.car_id,
      carModelId: selectedCarModelId?.id,
      vehicleId: vehicleId,
    };

    setVinLoading(true);

    getCarAllDetailsList(obj)
      .then((response) => {
        toast.success(response.data.message);

        setModalCarVin(true);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setVinLoading(false);
      });
  };

  const handleSerachByVinLive = (e) => {
    e.preventDefault();
    setLoadingVinType("live");

    const obj = {
      vin: search,
      lang: "pt",
      status: 1, // live
    };

    getCarModelByVin(obj)
      .then((response) => {
        const dataWithStatus = response.data.data.map((item) => ({
          ...item,
          status: 1,
        }));
        setVehicleVinLiveList(dataWithStatus);
        setModalCarVin(true);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoadingVinType(null);
      });
  };

  const handleSerachByVinLocal = (e) => {
    e.preventDefault();
    setLoadingVinType("local");

    const obj = {
      vin: search,
      lang: "pt",
      status: 2, // local
    };

    getCarModelByVin(obj)
      .then((response) => {
        const dataWithStatus = response.data.data.map((item) => ({
          ...item,
          status: 2,
        }));
        setVehicleVinLocalList(dataWithStatus);
        setModalCarVin(true);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoadingVinType(null);
      });
  };

  const handleSubmitGroupLiveTreeCar = (e, item) => {
    e.preventDefault();
    localStorage.setItem("selectedCatalogItem", JSON.stringify(item));

    const obj = {
      catalogId: item?.catalog_id,
      carId: item.car_id,
      status: 1,
    };

    getCarTreeByCar(obj)
      .then((response) => {
        const dataWithStatus = response.data.data.map((item) => ({
          ...item,
          status: 1,
        }));
        setPartCatalogLiveData(dataWithStatus);
        setKey("car_type_selection");
        setShowTab2(true);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoadingTreeCar(false);
      });
  };

  const handleSubmitGroupLocalTreeCar = (e, item) => {
    e.preventDefault();

    localStorage.setItem("selectedCatalogItem", JSON.stringify(item));

    const obj = {
      catalogId: item.catalog_id,
      carId: item.car_id,
      status: 2,
    };

    setLoadingTreeCar(true);

    getCarTreeByCar(obj)
      .then((response) => {
        const dataWithStatus = response.data.data.map((item) => ({
          ...item,
          status: 2,
        }));
        setPartCatalogData(dataWithStatus);
        setKey("car_type_selection");
        setShowTab2(true);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoadingTreeCar(false);
      });
  };

  const handleSubmitSchemaLiveByGroup = (e, item) => {
    let car_id = localStorage.getItem("selectedCatalogItem");
    let carId = JSON.parse(car_id);
    e.preventDefault();
    const obj = {
      catalogId: carId?.catalog_id,
      carId: carId.car_id,
      groupId: item?.id,
      partNameIds: "",
      status: 1,
    };

    setLoadingTreeCar(true);

    setItemCarType(item);

    getSchemaByGroup(obj)
      .then((response) => {
        const dataWithStatus = response.data.data.map((item) => ({
          ...item,
          status: 1,
        }));
        setSchemaByGroupLiveData(dataWithStatus);
        setKey("interactive_diagram_selection");
        setShowTab2(true);
        setShowTabInteractive(true);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoadingTreeCar(false);
      });
  };

  const handleSubmiPartLiveByGroup = (e, item) => {
    let car_id = localStorage.getItem("selectedCatalogItem");
    let carId = JSON.parse(car_id);
    e.preventDefault();
    setMainPartData(item);

    const obj = {
      catalogId: carId?.catalog_id,
      carId: carId.car_id,
      groupId: item?.groupId,
      status: 1,
    };

    setLoadingTreeCar(true);

    getPartByGroup(obj)
      .then((response) => {
        setPartByGroupLiveData(response.data.data);
        setShowTabInteractive(true);
        setShowTab3(true);
        setShowTab2(true);
        setKey("part_selection");
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoadingTreeCar(false);
      });
  };

  const handleSubmiPartAssign = (e, item) => {
    e.preventDefault();
    setMainPartData(item);

    const catalog_id = addedParts?.map((x) => x.catalog_id);

    const obj = {
      vehicle_id: vehicleProcessList?.vehicle_id
        ? vehicleProcessList?.vehicle_id
        : vehicleId,
      car_id: partData?.infoData?.car_id,
      catalog: partData?.infoData?.catalog_id,
      car_model_id: partData?.id,
      catalog_id: catalog_id,
    };

    createVehicleAddPartAssignCatalog(obj)
      .then((response) => {
        toast.success(response.data.message);

        sePartModal(false);
        setAddedParts([]);
        let data = {
          car_model_id: partData?.id,
          vehicle_id: vehicleProcessList?.vehicle_id
            ? vehicleProcessList?.vehicle_id
            : vehicleId,
        };
        getVehicleAddPartAssignCatalog(data)
          .then((response) => {
            setPartAssignDetails(response.data.data);
          })
          .catch((err) => {
            toast.dismiss();
            toast.error(Utils.getErrorMessage(err));
          });
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <div className="card card-primary">
            <div className="card-body">
              <div className="row justify-content-start mb-5 ms-1 me-1">
                <React.Fragment>
                  <div className="fileupload-content">
                    <div className="row justify-content-start mt-4 mb-4 align-items-center">
                      <div className="col-md-4">
                        <div
                          className="card-title m-0 float-left"
                          style={{ width: "100%" }}
                        >
                          <input
                            type="text"
                            className="form-control"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder={t("search_by_vin")}
                            style={{ marginLeft: "5px" }}
                          ></input>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="btn-row-vehical">
                          <button
                            type="button"
                            className="btn btn-primary nxt-btn d-none"
                            onClick={handleSerachByVinLocal}
                            disabled={loadingVinType === "local"}
                          >
                            {loadingVinType === "local" ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                {t("loading")}
                              </>
                            ) : (
                              <>
                                {t("serach_by_local_vin")}{" "}
                                <i className="bi bi-search"></i>
                              </>
                            )}
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary nxt-btn"
                            onClick={handleSerachByVinLive}
                            disabled={loadingVinType === "live"}
                          >
                            {loadingVinType === "live" ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                {t("loading")}
                              </>
                            ) : (
                              <>
                                {t("serach_by_live_vin")}{" "}
                                <i className="bi bi-search"></i>
                              </>
                            )}
                          </button>
                        </div>
                      </div>

                      <div className="row">
                        <div
                          className="col-md-12"
                          style={{ marginTop: "10px" }}
                        >
                          <div className="col-md-12">
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th>{t("brand_name")}</th>
                                  <th>{t("info_title")}</th>
                                  <th>{t("model")}</th>
                                  <th>{t("year")}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {carAllDetails ? (
                                  <tr>
                                    <td>{carAllDetails?.brand_name}</td>
                                    <td>{carAllDetails?.info_title}</td>
                                    <td>{carAllDetails?.model}</td>
                                    <td>{carAllDetails?.year}</td>
                                  </tr>
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="4"
                                      className="text-center text-muted"
                                    >
                                      {t("no_data_found")}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              </div>

              <div className="back-footer">
                <div className="row align-items-center">
                  <div className="col-4">
                    <button
                      type="button"
                      className="next-button btn btn-secondary"
                      onClick={() => setActiveTab("depreciation")}
                    >
                      <i className="bi bi-arrow-left"></i> {t("back")}
                    </button>
                  </div>
                  <div className="col-4 text-center">
                    <small style={{ color: "#9ca3af" }}>
                      {t("tool_label")}
                    </small>
                  </div>
                  <div className="col-4 text-end">
                    <button
                      type="button"
                      className="btn btn-primary nxt-btn"
                      onClick={() => navigate("/vehicle-process")}
                    >
                      {t("finish_process")}
                      <i className="bi bi-check2 ms-1"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal isOpen={modalCarVin} className="modal-fullscreen">
        <ModalHeader className="modal-custom-header">
          {t("car_model_by_vin")}
        </ModalHeader>
        <ModalBody>
          <div className="container-fluid">
            <div className="row">
              <div className="mt-4">
                <Tabs
                  id="controlled-tab-example"
                  activeKey={key}
                  onSelect={(k) => setKey(k)}
                  className="mb-3 nav-tap-modal"
                >
                  <Tab
                    eventKey="carSelection"
                    title={`${t("car_selection")}${search ? ` (${search})` : ""}`}
                    style={{
                      color: "#81bb42",
                    }}
                  >
                    <div className="card">
                      <div className="card-body">
                        <h3>{t("found_variants")}</h3>
                        <h6>
                          {t("cannot_identify_vin")}
                          <span
                            style={{
                              color: "#85c044",
                              marginLeft: "10px",
                            }}
                          >
                            {search}
                          </span>
                          {" — "}
                          {t("choose_most_appropriate")}
                        </h6>
                      </div>
                    </div>

                    {vehicleVinLiveList?.some((item) => item.infoData) && (
                      <div>
                        <div>
                          <h3>{t("seat")}</h3>
                          {/* <h6>
                           {t("region")} --------------------------- Europe
                         </h6>
                         <h6>{t("year")} ----------------------------- 2002</h6> */}
                        </div>
                      </div>
                    )}
                    <div>
                      <div className="vehicleThBg table-responsive min-height-0 pb-2">
                        {vehicleVinLiveList?.some((item) => item.infoData) ? (
                          <table className="rounded-table table table-striped table-bordered table-hover">
                            <thead>
                              <tr>
                                <th style={{ width: "10%" }}></th>
                                <th style={{ width: "10%" }}>
                                  {t("model_designation")}
                                </th>
                                <th style={{ width: "10%" }}>{t("name")}</th>
                                <th style={{ width: "10%" }}>
                                  {t("part_assign")}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {vehicleVinLiveList
                                .filter((item) => item.infoData)
                                .map((item, index) => (
                                  <tr key={index}>
                                    <th style={{ display: "flex" }}>
                                      <div
                                        className="edit-btn"
                                        style={{ cursor: "pointer" }}
                                        onClick={(e) => {
                                          if (item?.status === 1) {
                                            handleSubmitGroupLiveTreeCar(
                                              e,
                                              item?.infoData
                                            );
                                          } else if (item?.status === 2) {
                                            handleSubmitGroupLocalTreeCar(
                                              e,
                                              item?.infoData
                                            );
                                          }
                                        }}
                                      >
                                        <i className="bi bi-eye-fill"></i>
                                      </div>

                                      <div
                                        className="edit-btn"
                                        style={{
                                          cursor: "pointer",
                                          marginLeft: "10px",
                                        }}
                                        onClick={() => {
                                          setModalInfo(true);
                                          setInfoData(item);
                                        }}
                                      >
                                        <i className="bi bi-info-circle-fill"></i>
                                      </div>
                                    </th>
                                    <th style={{ cursor: "pointer" }}>
                                      {item.model}
                                    </th>
                                    <td style={{ cursor: "pointer" }}>
                                      {item.info_title}
                                    </td>
                                    <td style={{ cursor: "pointer" }}>
                                      <input
                                        type="radio"
                                        name="carSelection"
                                        value={item.car_model_id}
                                        checked={selectedCarModelId === item}
                                        onChange={() =>
                                          setSelectedCarModelId(item)
                                        }
                                        style={{ cursor: "pointer" }}
                                      />
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        ) : (
                          <div
                            style={{
                              textAlign: "center",
                              padding: "20px",
                              color: "#777",
                            }}
                          >
                            {t("no_data_available")}
                          </div>
                        )}
                      </div>
                    </div>
                  </Tab>

                  {showTab2 && (
                    <Tab
                      eventKey="car_type_selection"
                      title={`${t("car_type_selection")}${
                        search ? ` (${search})` : ""
                      }`}
                      style={{
                        color: "#81bb42",
                      }}
                    >
                      <div>
                        <div>
                          <h3>{t("parts_catalogs")}</h3>
                          <h6>
                            {mainCatalogData?.brand}{" "}
                            {mainCatalogData?.model_name}
                            <span
                              style={{
                                color: "#85c044",
                                marginLeft: "10px",
                              }}
                            >
                              {search}
                            </span>
                          </h6>
                        </div>
                      </div>

                      <div className="container-fluid">
                        <div className="row mt-4 justify-content-start">
                          {partCatalogLiveData?.map((card, cardIndex) => {
                            const showAll = showAllList[cardIndex];
                            const allItems = card.subGroups || [];
                            const visibleItems = showAll
                              ? allItems
                              : allItems.slice(0, 5);
                            const extraCount = allItems.length - 5;

                            return (
                              <div className="col-md-3 d-flex align-items-stretch">
                                <div
                                  className="card vehicle-card w-100"
                                  key={cardIndex}
                                >
                                  {/* <img
                                  src={card.img_url}
                                  alt="..."
                                  className="card-img-top"
                                  style={{
                                    borderRadius: "145px",
                                    width: "50%",
                                    display: "block",
                                    margin: "0 auto",
                                  }}
                                /> */}
                                  <div className="card-header">
                                    <div
                                      className="card-title-custom"
                                      type="button"
                                      onClick={(e) => {
                                        handleSubmitSchemaLiveByGroup(e, card);
                                      }}
                                    >
                                      {card.name}
                                    </div>
                                  </div>
                                  <div className="card-body">
                                    <ul
                                      style={{
                                        listStyleType: "none",
                                        paddingLeft: 0,
                                        margin: 0,
                                      }}
                                    >
                                      {/* <li
                                      key="level-1"
                                      style={{
                                        fontWeight: "bold",
                                        color: "#000",
                                        marginBottom: "5px",
                                        cursor: "pointer",
                                      }}
                                      onClick={(e) => {
                                        handleSubmitSchemaLiveByGroup(e, card);
                                      }}
                                    >
                                      {card.name}
                                    </li> */}

                                      {/* Subgroups (Level 2 or deeper) */}
                                      {visibleItems?.map((item, index) => (
                                        <li
                                          key={index}
                                          style={{
                                            fontWeight: "normal",
                                            color: "#555",
                                            cursor: "pointer",
                                          }}
                                          onClick={(e) => {
                                            handleSubmitSchemaLiveByGroup(
                                              e,
                                              item
                                            );
                                          }}
                                        >
                                          {item.name}
                                        </li>
                                      ))}
                                    </ul>
                                    <div className="d-flex justify-content-center mt-4 mb-4">
                                      {allItems?.length > 5 && (
                                        <button
                                          onClick={() =>
                                            toggleShowAll(cardIndex)
                                          }
                                          className="view-more"
                                        >
                                          {showAll
                                            ? t("show_less")
                                            : `${t("show_more")} (${extraCount})`}
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </Tab>
                  )}

                  {showTabInteractive && (
                    <Tab
                      eventKey="interactive_diagram_selection"
                      title={`${t("interactive_diagram_selection")}${
                        search ? ` (${search})` : ""
                      }`}
                      style={{
                        color: "#81bb42",
                      }}
                    >
                      <div>
                        <div>
                          <h3>{itemCarType?.name}</h3>
                          <h6>
                            {mainCatalogData?.brand}{" "}
                            {mainCatalogData?.model_name}
                            <span
                              style={{
                                color: "#85c044",
                                marginLeft: "10px",
                              }}
                            >
                              {search}
                            </span>
                          </h6>
                        </div>
                      </div>
                      <div className="container-fluid">
                        <div className="row mt-4 justify-content-start">
                          {(schemaByGroupLiveData?.length > 0
                            ? schemaByGroupLiveData
                            : schemaByGroupLocalData
                          )?.map((card, cardIndex) => {
                            const showAll = showAlTypeList[cardIndex];
                            const allItems = card.part_names || [];
                            const visibleItems = showAll
                              ? allItems
                              : allItems.slice(0, 4);
                            const extraCount = allItems?.length - 4;
                            return (
                              <div className="col-md-3 d-flex align-items-stretch">
                                <div
                                  key={cardIndex}
                                  className="card vehicle-card w-100"
                                >
                                  <div className="card-header card-header-check">
                                    <img
                                      src={card.img}
                                      alt="..."
                                      className="img-fluid"
                                      style={{
                                        display: "block",
                                      }}
                                    />
                                  </div>
                                  <div
                                    className="card-body"
                                    style={{ color: "black" }}
                                  >
                                    <div className="card-inner-section">
                                      <h5
                                        className="card-title"
                                        style={{
                                          fontSize: "larger",
                                          fontWeight: 700,
                                          cursor: "pointer",
                                        }}
                                        onClick={(e) => {
                                          handleSubmiPartLiveByGroup(e, card);
                                        }}
                                      >
                                        {card?.name}
                                      </h5>
                                      <div className="w-100">
                                        <div className="w-100">
                                          {visibleItems?.map((item, index) => (
                                            <span
                                              className="badge sqaure-pill text-dark bg-light border px-3 py-2 d-inline-block text-center"
                                              style={{
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                marginLeft: "5px",
                                                marginTop: "5px",
                                              }}
                                            >
                                              {item?.name}
                                            </span>
                                          ))}
                                        </div>

                                        {allItems?.length > 5 && (
                                          <button
                                            onClick={() =>
                                              toggleShowTypeAll(cardIndex)
                                            }
                                            style={{
                                              background: "none",
                                              border: "none",
                                              color: "#007bff",
                                              cursor: "pointer",
                                              padding: 0,
                                              marginTop: "5px",
                                            }}
                                          >
                                            {showAll
                                              ? "Show less"
                                              : `Show more (${extraCount})`}
                                          </button>
                                        )}
                                      </div>{" "}
                                      <div className="row-11">
                                        <small className="text-muted">
                                          {card?.description}
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </Tab>
                  )}

                  {showTab3 && (
                    <Tab
                      eventKey="part_selection"
                      title={`${t("part_selection")}${search ? ` (${search})` : ""}`}
                      style={{
                        color: "#81bb42",
                      }}
                    >
                      <div className="container-fluid">
                        <div>
                          <h4
                            style={{
                              color: "black",
                            }}
                          >
                            {mainPartData?.name}
                          </h4>
                          <h6>
                            {mainCatalogData?.brand}{" "}
                            {mainCatalogData?.model_name}
                            <span
                              style={{
                                color: "#85c044",
                                marginLeft: "10px",
                              }}
                            >
                              {search}
                            </span>
                          </h6>
                        </div>

                        <React.Fragment>
                          <div className="row">
                            <div className="col-md-4 d-flex align-items-stretch">
                              <div className="card w-100">
                                <div className="card-body px-4 mt-3">
                                  <img
                                    src={partByGroupLiveData.img}
                                    alt="..."
                                    className="img-fluid battery-images"
                                    style={{
                                      borderRadius: "145px",
                                      maxHeight: "550px",
                                      display: "block",
                                      margin: "0 auto",
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-8 d-flex align-items-stretch">
                              <div className="card w-100">
                                <div className="card-body px-4 mt-3">
                                  {partByGroupLiveData?.partGroups?.map(
                                    (item, groupIndex) => (
                                      <div key={groupIndex}>
                                        <h4>{item.name}</h4>
                                        <div
                                          style={{
                                            maxHeight: "550px",
                                            overflowY: "auto",
                                            border: "1px solid #dee2e6",
                                          }}
                                        >
                                          <table className="table table-bordered">
                                            <thead
                                              className="table-light"
                                              style={{
                                                position: "sticky",
                                                top: 0,
                                                backgroundColor: "#f8f9fa",
                                                zIndex: 1,
                                              }}
                                            >
                                              <tr>
                                                <th>{t("number")}</th>
                                                <th>{t("name")}</th>
                                                <th>{t("code")}</th>
                                                <th>{t("description")}</th>
                                                <th></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {item.parts?.map(
                                                (items, partIndex) => {
                                                  const rowId = `collapse-${groupIndex}-${partIndex}`;

                                                  return (
                                                    <React.Fragment key={rowId}>
                                                      <tr>
                                                        <td>
                                                          {
                                                            items?.positionNumber
                                                          }
                                                        </td>
                                                        <td>{items?.name}</td>
                                                        <td>{items?.number}</td>
                                                        <td>
                                                          <div
                                                            dangerouslySetInnerHTML={{
                                                              __html:
                                                                items?.description,
                                                            }}
                                                          />
                                                        </td>
                                                        <td>
                                                          <button
                                                            type="button"
                                                            className="btn btn-block btn-primary"
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "blue",
                                                              width: "100px",
                                                              marginTop: "10px",
                                                            }}
                                                            onClick={(e) => {
                                                              toggleRowLive(
                                                                items?.number
                                                              );
                                                            }}
                                                          >
                                                            {t("see_price")}{" "}
                                                          </button>
                                                        </td>
                                                      </tr>
                                                    </React.Fragment>
                                                  );
                                                }
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      </div>
                    </Tab>
                  )}
                </Tabs>
              </div>
            </div>
          </div>
        </ModalBody>

        <ModalFooter>
          {vehicleVinLiveList?.some((item) => item.infoData) && (
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleSaveVin}
              style={{ width: "120px", marginTop: "10px" }}
              disabled={vinLoading}
            >
              {vinLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {t("saving")}...
                </>
              ) : (
                <>
                  {t("save")}
                  <i className="bi bi-save ms-2"></i>
                </>
              )}
            </button>
          )}

          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleCarVinModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalInfo}>
        <ModalHeader>{infoData?.brand}</ModalHeader>

        <ModalBody>
          <div className="row">
            <div className="col-md-6">
              <img
                src={infoData?.infoData?.model_img}
                alt="..."
                className="card-img-top"
                style={{
                  borderRadius: "145px",
                  width: "50%",
                  display: "block",
                  margin: "0 auto",
                }}
              />
            </div>

            <div className="col-md-6">
              <span
                style={{
                  fontWeight: 700,
                }}
              >
                {t("description")}
              </span>{" "}
              : {infoData?.infoData?.description}
            </div>
          </div>
          <div className="row">
            <div className="col-md-12" style={{ marginTop: "10px" }}>
              <div className="col-md-12">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>{t("name")}</th>
                      <th>{t("value")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {infoData?.infoData?.parameters?.map((item, index) => (
                      <tr key={index}>
                        <td>{item?.name}</td>
                        <td>{item?.value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleInfoModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={priceModal}>
        <ModalHeader>{codeData}</ModalHeader>

        <ModalBody>
          <div className="row">
            <div className="col-md-12" style={{ marginTop: "10px" }}>
              <div className="col-md-12">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>{t("price")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {partPriceLiveData?.map((car, i) => (
                      <tr key={i}>
                        <td>{car?.price} €</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handlePriceClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={partModal} size="xl">
        <ModalHeader>
          {t("part_assign")}
          <button
            type="button"
            className="button-Close d-none"
            onClick={handlePartClose}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </ModalHeader>
        <Form method={`post`} onSubmit={handleSubmiPartAssign}>
          <ModalBody>
            <div className="row">
              <div className="row">
                <div className="col-md-6">
                  <div className="">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={params.search}
                      onChange={(e) => handleParams(e, "search")}
                      maxLength={50}
                      placeholder={t("search")}
                    />
                  </div>
                  <div
                    className="vehicleThBg table-responsive tableScroll table-scroll-modal min-height-0"
                    style={{ marginTop: "10px" }}
                  >
                    <table className="rounded-table table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th style={{ width: "10%" }}>{t("part")}</th>

                          <th style={{ width: "0%" }}>{t("action")}</th>
                        </tr>
                      </thead>

                      <tbody>
                        {filteredPartAssignList?.length > 0 ? (
                          filteredPartAssignList?.map((item, index) => (
                            <tr key={index}>
                              <td>{item?.namePartPT}</td>

                              <td>
                                <Button
                                  className="addBtn"
                                  onClick={() => handleAddClick(item)}
                                  style={{
                                    backgroundColor: "green",
                                    color: "white",
                                    cursor: "pointer",
                                  }}
                                >
                                  <i className="bi bi-plus-lg"></i>
                                </Button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr className="scrollBrdr">
                            <td colSpan="100%">{t("no_record_found")}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="card-footer clearfix card-footer-part">
                    <div className="pagination pagination-sm m-0  paginationRight">
                      <Pagination
                        activePage={params.page}
                        itemsCountPerPage={parseInt(params.limit)}
                        totalItemsCount={parseInt(totalRecords)}
                        pageRangeDisplayed={5}
                        itemClass={`page-item`}
                        linkClass={`page-link`}
                        onChange={(e) => handleParams(e, "pagination")}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6" style={{ marginTop: "56px" }}>
                  <div className="vehicleThBg table-responsive tableScroll table-scroll-modal min-height-0">
                    <table className="rounded-table table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th style={{ width: "10%" }}>{t("part")}</th>

                          <th style={{ width: "0%" }}>{t("action")}</th>
                        </tr>
                      </thead>

                      <tbody>
                        {addedParts?.length > 0 ? (
                          addedParts?.map((item, index) => (
                            <tr key={index}>
                              <td>{item?.namePartPT}</td>

                              <td className="">
                                <button
                                  className="btn-danger-delete"
                                  onClick={() =>
                                    handleRemoveClick(item.catalog_id)
                                  }
                                >
                                  <i className="bi bi-trash3"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr className="scrollBrdr">
                            <td colSpan="100%">{t("no_record_found")}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handlePartClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>
            {loading === true ? (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("loading_dots")}
              </button>
            ) : (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("submit")} <i className="bi bi-check2"></i>
              </button>
            )}
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default VehicleModelByVIN;
